<template>
  <div v-if="otherImpacts.length" class="pa-4">
    <h3 class="font-weight-bold">
      {{ title }}
    </h3>
    <ul>
      <li
        v-for="(impact, index) in formattedImpacts"
        :key="index"
        class="ma-0 pa-2"
      >
        <h4 class="font-weight-bold" v-html="impact.title + ':'"></h4>
        <div class="caption hyp-trigger-text" v-html="impact.text"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import lodashOrderBy from "lodash/orderBy";
export default {
  name: "RisksScenariosOtherImpacts",
  components: {},
  props: {
    title: {
      type: String,
    },
    otherImpacts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    formattedImpacts() {
      return lodashOrderBy(this.otherImpacts, ["title"], ["asc"]);
    },
  },
};
</script>

<style scoped>
.v-application .font-weight-bold {
  font-weight: 700 !important;
}
</style>
